import React, { useState } from 'react';
import styled from 'styled-components';
import { FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      content: 'AKAS has transformed the way we manage our business operations with its comprehensive cloud-based modules, streamlining everything from CRM to accounting seamlessly.',
      author: 'Chan Sombath',
      position: 'CEO, OWP'
    },
    {
      id: 2,
      content: 'AKAS has transformed our operations with its comprehensive cloud-based HR system, streamlining our HR processes and significantly boosting our efficiency.',
      author: 'Hour Chansokun',
      position: 'Administrative Director, iDE Cambodia'
    },
    {
      id: 3,
      content: 'AKAS has revolutionized our HR operations through its all-in-one cloud-based HR platform, simplifying our HR workflows and greatly enhancing our overall productivity.',
      author: 'Tham Thavy',
      position: 'Head of HR, ICF Cambodia'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <Section>
      <div className="container">
        <SectionHeader>
          <Badge>Our Testimonials</Badge>
          <Title>What Our Clients Say</Title>
        </SectionHeader>
        
        <TestimonialContainer>
          <QuoteIcon>
            <FaQuoteLeft />
          </QuoteIcon>
          
          <TestimonialSlider>
            <TestimonialContent>
              {testimonials[currentIndex].content}
            </TestimonialContent>
            
            <AuthorInfo>
              <AuthorName>{testimonials[currentIndex].author}</AuthorName>
              <AuthorPosition>{testimonials[currentIndex].position}</AuthorPosition>
            </AuthorInfo>
          </TestimonialSlider>
          
          <SliderControls>
            <SliderButton onClick={handlePrev}>
              <FaChevronLeft />
            </SliderButton>
            <SliderDots>
              {testimonials.map((_, index) => (
                <SliderDot 
                  key={index} 
                  active={index === currentIndex}
                  onClick={() => setCurrentIndex(index)}
                />
              ))}
            </SliderDots>
            <SliderButton onClick={handleNext}>
              <FaChevronRight />
            </SliderButton>
          </SliderControls>
        </TestimonialContainer>
      </div>
    </Section>
  );
};

const Section = styled.section`
  padding: 5rem 0;
`;

const SectionHeader = styled.div`
  text-align: left;
  max-width: 800px;
  margin-bottom: 3rem;
`;

const Badge = styled.div`
  display: inline-block;
  padding: 0.35rem 1rem;
  background-color: rgba(0, 0, 0, 0.1);
  color: var(--text-dark);
  font-weight: 600;
  font-size: 0.875rem;
  border-radius: 30px;
  margin-bottom: 1rem;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  color: var(--text-dark);
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const TestimonialContainer = styled.div`
  position: relative;
  max-width: 900px;
  margin: 0 auto;
  padding: 3rem 2rem;
`;

const QuoteIcon = styled.div`
  font-size: 4rem;
  color: var(--primary-color);
  opacity: 0.2;
  position: absolute;
  top: 0;
  left: 0;
`;

const TestimonialSlider = styled.div`
  text-align: left;
`;

const TestimonialContent = styled.blockquote`
  font-size: 1.75rem;
  line-height: 1.5;
  color: var(--text-dark);
  font-weight: 500;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
  
  @media (max-width: 576px) {
    font-size: 1.25rem;
  }
`;

const AuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
`;

const AuthorName = styled.h4`
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
`;

const AuthorPosition = styled.p`
  font-size: 1rem;
  color: var(--text-dark);
  opacity: 0.8;
`;

const SliderControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
`;

const SliderButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--text-dark);
  font-size: 1.25rem;
  padding: 0.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    color: var(--primary-color);
  }
`;

const SliderDots = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const SliderDot = styled.button<{ active: boolean}>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.active ? 'var(--text-dark)' : 'rgba(0, 0, 0, 0.2)'};
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: var(--primary-color);
  }
`;

export default TestimonialsSection; 